<template>
    <div id="body-wrap" class="">
        <LayoutHeader />
        <Realtime />
        <Footer />
        <FooterPc />
        <Common />
    </div>
</template>

<script>
import LayoutHeader from '@/views/layout/LayoutHeader.vue';
import Footer from "@/views/layout/Footer";
import FooterPc from "@/views/layout/FooterPc";
import Realtime from '@/views/realtime/Realtime.vue';
import Common from '@/views/common/Common.vue';
import { defualtMeta } from '@/confs/vue.meta';

import gripUtil from "@/libs/grip.util";
import { mapGetters } from 'vuex';

export default {
    name: 'RealtimeApp',
    metaInfo: {
        meta: defualtMeta,
    },
    components: {
        LayoutHeader,
        Footer,
        FooterPc,
        Realtime,
        Common,
    },

    computed: {
    },
    created() {
        this.$store.dispatch('FETCH_REALTIME_CITY_LIST');

        this.$eventBus.$once('NaverMap::map-loaded', (map)=>{
            this.$store.dispatch('SET_NAVER_MAPS', map);
        });
        this.$eventBus.$once("DrawRegionNaverMap::completed-draw-region", geoJsonDrawing => {
            this.$store.dispatch("SET_GEO_JSON_DRAWING", geoJsonDrawing);
            // 실시간 데이터 get
            this.getRealtimeData();
            setInterval(()=>{
                this.getRealtimeData();
            }, 1000 * 60 * 10);
            let poms = [];
            poms.push(this.$store.dispatch("FETCH_UTIC_CCTV_POP_URL"));
            Promise.all(poms).then(() => {
                this.$store.dispatch('FETCH_UTIC_CCTV_LIST');
            });
            this.$store.dispatch("FETCH_BUILDING_ALARM_LIST");
            // this.$store.dispatch("FETCH_REALTIME_CITY_SELECTED_LIST");
            this.$store.dispatch("FETCH_CULTURE_EVENT");
            
            // this.$store.dispatch("FETCH_BUILDING_PERMIT_LIST");

        });
    },
    methods: {
        getRealtimeData(){
            let now = new Date();
            now.setDate(now.getDate() - 0);
            let nowStr = now.format('yyyyMMdd');
            this.$store.dispatch('FETCH_SAFETY_CODE_LIST');
            // 재난안전
            let q = 'stateMode=1&intervalDay=1&searchFromDate=' + nowStr + '000000&searchToDate=' + nowStr + '235959';
            if(process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
                q = 'stateMode=1&intervalDay=999&searchFromDate=20210830000000&searchToDate=20210830235959';
            }
            this.$store.dispatch('FETCH_SAFETY_LIST', q);
            this.$store.dispatch('FETCH_SAFETY_TODAY_LIST');

            // 돌발
            // q = 'whereNot=val2::4&whereLike=val4::' + encodeURIComponent('강남구') + '&searchActivityYn=1&whereStartLike=basdtVal::' + nowStr;
            q = 'whereNot=val2::4&searchActivityYn=1&whereStartLike=basdtVal::' + nowStr;
            this.$store.dispatch('FETCH_ACCIDENT_LIST', q);

            // 대기
            this.$store.dispatch('FETCH_AIR_HJD_SENSOR_LIST');
            this.$store.dispatch('FETCH_RAINFALL_LIST');
            this.$store.dispatch('FETCH_DONG_RAINFALL_INFO');
            this.$store.dispatch('FETCH_AIR_FORECAST_LIST');

            let proms = [];
            proms.push(this.$store.dispatch('FETCH_SEOUL_HJD_CODE_LIST'));
            proms.push(this.$store.dispatch('FETCH_REALTIME_CITY_LIST'));
            Promise.all(proms).then(()=>{
                // 하천수위
                this.$store.dispatch('FETCH_WATER_LEVEL_LIST', 'searchMaxBaseColumns=basdtVal&where=val4::101');
                // 하천수위_재난예경보시스템(1870 추가)
                this.$store.dispatch('FETCH_DIS_WATER_LIST', 'searchMaxBaseColumns=basdtVal');
                this.$eventBus.$emit('SeoulmapDataLoader:loaded-data');
            });

            // 상수도
            this.$store.dispatch('FETCH_WATER_QUALITY_LIST');

            // 서울지도
            this.$store.dispatch('FETCH_SAFETY_SGG_CENTER_LIST');
            this.$store.dispatch('FETCH_AIR_SGG_LIST');
            this.$store.dispatch('FETCH_WATER_SGG_QUALITY_LIST');
            this.$store.dispatch('FETCH_SEOUL_RAINFALL_LIST');

            // 모기방역
            this.$store.dispatch("FETCH_MOSQUITO_LIST");

            // 매개모기
            this.$store.dispatch("FETCH_MEDIUM_MOSQ_LIST");

            // 재난문자
            // this.$store.dispatch("FETCH_DISASTER_TXT");

            // setInterval(function() {
            //     this.$store.dispatch('FETCH_REALTIME_CITY_LIST').then(function() {
            //         this.$eventBus.$emit('SeoulmapDataLoader:reloaded-data');
            //     }.bind(this));
            // }.bind(this), 1000 * 60 * 10);
        },
    },
};
</script>
